module.exports = __webpack_public_path__ + "static/media/designCommunity.6938bb13.svg";